import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-left-more",
  "use": "icon-ic-left-more-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-ic-left-more\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 12h12V0H0z\" /><path d=\"M3.75 9.021V2.98a.375.375 0 0 1 .593-.305l4.23 3.022a.375.375 0 0 1 0 .61l-4.23 3.02a.375.375 0 0 1-.593-.305z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol